import React from "react";

import './FooterMinView.scss';

export default class FooterMinView extends React.Component {
    render() {
        return (
            <div id="footerMin" className="aliC font12">
                © 2022 WeVideo, Inc.&nbsp;&nbsp;|&nbsp;&nbsp;<a href="/terms-of-use" target="_blank" rel="noopener">Terms
                of Use</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="/privacy" target="_blank" rel="noopener">Privacy
                Policy</a>
            </div>
        )
    }
}